import { useState, useContext, useEffect } from "react";
import styles from "../Settings.module.css";
import PluginsContext from "config/context/pluginsContext";
import GuiContext from "config/context/guiContext";
import ThemeContext from "config/context/themeContext";
import EncryptionContext from "config/context/encryptionContext";
import BackUp from "components/settings/BackUp";
import RedisImport from "components/settings/RedisImport";
import MongoImport from "components/settings/MongoImport";
import ModalContext from "config/context/modalContext";
import PrivateKeyStorageModal from "features/permissions/components/modals/PrivateKeyStorageModal";
import EnableEncryptionSettings from "./EnableEncryptionSettings";
import { useModalSystem } from "config/context/ModalSystemContext";

const PluginSettings = () => {

  const initialModalState = {
    privateKey: false,
    redisImport: false,
    mongoImport: false,
  }

  const { getActiveByAccountName } = useContext(PluginsContext);
  const { modal, handleModal } = useContext(ModalContext);
  // const [openModal, setOpenModal] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [modalControl, setModalControl] = useState({ ...initialModalState });
  const handleDropDown = () => setDropDownOpen((prev) => !prev);
  const [encryptionSettings, setEncryptionSettings] = useState(false);

  const {
    userData: { guiname },
  } = useContext(GuiContext);
  const { setEncryptionToDefault, encryption } = useContext(EncryptionContext);
  const { openModal } = useModalSystem();
  const allAreActive = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

  const { dark } = useContext(ThemeContext);
  const [active, setActive] = useState([]);
  //     [("1","Encryption"),
  //     ("2", "Backup", ),
  //     ("3", "Replica sync",),
  //     ("4", "MongoDB proxy", ),
  //     ("5", "Export data"),
  //     ("6", "SQL Connector"),
  //     ("7", "Hot Key"),
  //     ("8", "Import Redis"),
  //     ("10", "Import Mongo"),
  //     ("12", "AI Database Architect")
  // ]

  useEffect(() => {
    let activePluginsByAccount = getActiveByAccountName(guiname);
    if (activePluginsByAccount?.active)
      setActive(activePluginsByAccount?.active);
  }, [guiname]);

  const showModal = (modalName) => {
    setModalControl(prev => ({ ...prev, [modalName]: true }));
    handleModal(true);
  };

  useEffect(() => {
    if (!modal) {
      setModalControl({ ...initialModalState });
    }
  }, [modal]);

if(!active?.length) {
  return(<p>You don't have any activated plugins yet.</p>)
}

  return (
    <section className={styles.pluginSettings}>
      <div className={styles.settingsContainer}>
        {active.includes(7) && (
          <div onClick={() => showModal('privateKey')}>
            <img
              src={`../img/settings/pkeyStore${dark ? "-dark" : ""}.svg`}
              alt="pkeyStore"
            />
            Temporarily store the Private Key
          </div>
        )}
        {active.includes(1) && (
          <div onClick={() => { encryption ? setEncryptionToDefault() : setEncryptionSettings(true); }}>
            <img
              src={`../img/settings/encryption${dark ? "-dark" : ""}.svg`}
              alt="encryption"
            />
            <>{encryption ? "Disable" : "Enable"} Encryption</>
            {encryptionSettings && <EnableEncryptionSettings setEncryptionSettings={setEncryptionSettings}/>}
          </div>
        )}
        {active.includes(2) && (
          <div onClick={handleDropDown}>
            <img
              src={`../img/settings/backup${dark ? "-dark" : ""}.svg`}
              alt="backup"
            />
            Server Backup
          </div>
        )}
        {dropDownOpen && (
          <>
            <BackUp className={styles.dropDownOptions} />
          </>
        )}
        {active.includes(8) && (
          <div onClick={() => showModal('redisImport')}>
            <img
              src={`../img/settings/redis${dark ? "-dark" : ""}.svg`}
              alt="redis import"
            />
            Redis Import
          </div>
        )}
        {active.includes(10) && (
          <div onClick={() => showModal('mongoImport')}>
            <img
              src={`../img/settings/mongo${dark ? "-dark" : ""}.svg`}
              alt="mongo import"
            />
            Mongo Import
          </div>
        )}
        {active.includes(6) && (
          <div onClick={() => openModal('MF_IMPORT')}>
            <img
              width={18}
              src={`../img/settings/multiformat${dark ? "-dark" : ""}.svg`}
              alt="MultiFormat import"
            />
            MultiFormat Import
          </div>
        )}
      </div>
      {modalControl.privateKey && <PrivateKeyStorageModal />}
      {modalControl.redisImport && <RedisImport />}
      {modalControl.mongoImport && <MongoImport />}
    </section>
  );
};

export default PluginSettings;
